



























import { Vue, Component, Prop } from 'vue-property-decorator';


const HAMBURGER_THRESHOLD = 1087;

const FORM_FIELD_NAVBAR_LINKS = [
	{
		to: '/docs/fields/number',
		text: 'Formidable Number Field'
	},
	{
		to: '/docs/fields/text',
		text: 'Formidable Text Field'
	},
	{
		to: '/docs/fields/textarea',
		text: 'Formidable Textarea Field'
	},
	{
		to: '/docs/fields/email',
		text: 'Formidable Email Field'
	},
	{
		to: '/docs/fields/password',
		text: 'Formidable Password Field'
	},
	{
		to: '/docs/fields/file',
		text: 'Formidable File Field'
	},
	{
		to: '/docs/fields/link',
		text: 'Formidable Link Field'
	},
	{
		to: '/docs/fields/date',
		text: 'Formidable Date Field'
	},
];

@Component
export default class Navbar extends Vue {

	private isActive: boolean = false;
	private windowWidth!: number;
	private windowHeight!: number;
	private readonly HAMBURGER_THRESHOLD = HAMBURGER_THRESHOLD;
	private readonly FORM_FIELD_NAVBAR_LINKS = FORM_FIELD_NAVBAR_LINKS;

	private toggleActive(activeState?: boolean) {
		if (activeState == null || !((activeState as any) instanceof Boolean)) {
			this.isActive = !this.isActive;
			return;
		}
		this.isActive = activeState || !this.isActive;
	}

	private mounted() {
		this.checkWindowWidth();
		this.$nextTick(function() {
			window.addEventListener('resize', this.checkWindowWidth);
		});
	}

	private isPastThreshold() {
		return document.documentElement.clientWidth > this.HAMBURGER_THRESHOLD;
	}

	private checkWindowWidth() {
		this.isActive = this.isPastThreshold();
	}

	private beforeDestroy() {
		window.removeEventListener('resize', this.checkWindowWidth);
	}
}
